import React, { useEffect, useState } from 'react';

import { useSmartico } from 'components/ClientProfile/Achievements/Smartico';
import { getStoreItems } from 'components/Pages/Store/getStoreItems';

/**
 * Smartico Store item-count badge for the navigation entries (bottom tab bar +
 * hamburger menu), mirroring `PromotionsCounter`. Fetches the count once
 * Smartico is ready so it shows up front. Renders nothing while the count is 0.
 */
const StoreCounter = () => {
  const { isReadySmartico } = useSmartico();
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!isReadySmartico) return undefined;

    let active = true;

    getStoreItems()
      .then(items => {
        if (active) setCount(items.length);
      })
      .catch(() => {
        if (active) setCount(0);
      });

    return () => {
      active = false;
    };
  }, [isReadySmartico]);

  if (!count) {
    return null;
  }

  return <div className="menu-item-counter">{count > 99 ? '99+' : count}</div>;
};

export default StoreCounter;
